<ion-content class="garment-listing">
    <app-header [isParentPage]="false" [title]="'Web Product Edit'"></app-header>
    <div class="loading-container" style="padding-top:15%;" *ngIf="!loading">
        <ion-spinner></ion-spinner>
    </div>
    <ng-container>
    <input type="hidden" />

    <ion-grid *ngIf="webProductAdmin">
      <ion-row>
        <ion-col size="2">
          <b>Function</b>
        </ion-col>
        <ion-col size="2.5">
            <ion-select  interface="popover" class="inputCss" [(ngModel)]="selectedFunction">
            <ion-select-option value="update">Update</ion-select-option>
            <ion-select-option value="delete">Delete</ion-select-option>
          </ion-select>
        </ion-col>

      </ion-row>
 <ion-row>
   <ion-col size="2">
        <ion-row size="2">
          <b>Product Code</b>
        </ion-row >
         <ion-row size="2" style="margin-top:30px">
            <b>Short Name</b>
          </ion-row>
           <ion-row size="2" style="margin-top:30px">
          <b>Image File</b>  
        </ion-row>
    </ion-col>
  <ion-col>
           <ion-row size="5">
           <ion-input  type="text" size="50" [(ngModel)] ="webProductAdmin.productCode" class="inputCss" disabled></ion-input>
        </ion-row>
          <ion-row size="5" style="margin-top:10px">
              <ion-input type="text" size="50"  [(ngModel)] ="webProductAdmin.shortName" class="inputCss"></ion-input>
          </ion-row >
            <ion-row size="5" style="margin-top:10px">
             <ion-select  size="5" interface="popover" [(ngModel)]="selectedImage" class="inputCss" placeholder="Select Image">
            <ion-select-option  *ngFor="let img of images" [value]="img">
            {{ img }}
            </ion-select-option>
        </ion-select>
        </ion-row>
      </ion-col>
      <ion-col style="padding-left:2%">
          <ion-row size="2">
            <b>Thumbnail</b>
          </ion-row>
            <ion-row size="3">
              <img  style="width:120px;height:120px"[src]="getImageUrl(selectedImage)"  />
          </ion-row>
        </ion-col>
  </ion-row>
    

      <ion-row>
        <ion-col size="2">
          <b>Description</b>
        </ion-col>
        <ion-col size="8">
              <ion-textarea rows="10" cols="70"   [(ngModel)] ="webProductAdmin.description" title="desc"></ion-textarea>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col size="2"></ion-col>
        <ion-col size="4">
          <b>To view new content in box below click:</b>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col size="2"></ion-col>
        <ion-col size="3">
          <ion-button expand="block" (click)=displayHtml()>View New Description</ion-button>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col size="2"></ion-col>
        <ion-col size="8">
          <ion-card>
            <ion-card-header style="background-color: #006633; padding: 1px;">
              <ion-card-title>View of Description</ion-card-title>
            </ion-card-header>
            <ion-card-content>
              <div id="displayArea" [innerHTML]="displayedDescription">
              </div>
            </ion-card-content>
          </ion-card>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col size="5"></ion-col>
        <ion-col size="2">
            <ion-button expand="block" (click)="UpdateProduct()">Save to Database!</ion-button>
        </ion-col>
        <ion-col size="5">
        
        </ion-col>
      </ion-row>
    </ion-grid>
  </ng-container>
</ion-content>
